import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { ServerDataResponse, UserLoginData } from '@models/models';
import { TwoFaAuthenticationDataService } from '@services/user/two-fa-authentication.data.service';
import { TwoFactorAuthorization } from '@models/two-fa.models';

@Injectable()
export class TwoFactorAuthorizationInterceptor implements HttpInterceptor {
	constructor(
		private twoFaAuthenticationService: TwoFaAuthenticationDataService
	) {}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next
			.handle(req)
			.catch((err: HttpErrorResponse): Observable<HttpEvent<any>> =>
				this.handleTwoFaProcess(err, req)
			);
	}

	private handleTwoFaProcess(
		err: HttpErrorResponse,
		req
	): Observable<HttpEvent<any>> {
		if (err.status === 401) {
			if (err.error.errorCode === 212) {
				this.loadTwoFaLoginModal(req, err);
				return Observable.empty();
			}
			if (err.error.errorCode === 213) {
				this.loadTwoFaSetupModal();
				return Observable.empty();
			}
		}
		return Observable.throw(err);
	}

	private loadTwoFaLoginModal(req, err): void {
		this.twoFaAuthenticationService.setTwoFaModalControlState({
			state: true,
			action: 'LOGIN',
			payload: {
				userPayload: {
					userData: this.gatherLoginData(req.body),
					authorizationKey: req.headers.get('authorization')
				},
				recoverUser2FA: err.error.recoverUser2FA
			}
		});
	}

	private loadTwoFaSetupModal(): void {
		this.twoFaAuthenticationService
			.get2FaMetadataForSetup()
			.subscribe((data: ServerDataResponse<TwoFactorAuthorization>): void =>
				this.twoFaAuthenticationService.setTwoFaModalControlState({
					state: true,
					action: 'SETUP',
					payload: { user2faState: data.data.user2faState, loginActions: true }
				})
			);
	}

	private gatherLoginData(data): UserLoginData {
		const userData: UserLoginData = {} as UserLoginData;
		for (const pair of data.entries()) {
			userData[pair[0]] = pair[1];
		}
		return userData;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/interceptors/twoFa.interceptor.ts